import useInView from '../hooks/useInView';
import '../styles/Reveal.css';

/**
 * Fades a block in as it scrolls into view. Renders a plain element with the
 * content always present in the DOM — only opacity and transform change, so
 * nothing is hidden from search engines or assistive tech.
 */
const Reveal = ({ as: Tag = 'div', className = '', children, ...rest }) => {
  const [ref, inView] = useInView();

  return (
    <Tag
      ref={ref}
      className={`reveal${inView ? ' reveal--in' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
